import * as Yup from 'yup';
import {
  createEmailSchema,
  createRequiredBooleanSchema
} from '@spa/lib/formsSchemas/commonValidations';
import { FormatMessageFunction } from '@spa/lib/i18n/common/FormatMessageFunction';
import { NewsletterSubscribeFormFields } from '@spa/components/forms/newsletter-subscribe-form/newsletterSubscribeFormTypes';
import { Schema } from 'yup';

const newsletterSubscribeFormSchemaValidationV2 = (
  formatMessage: FormatMessageFunction
): Schema<NewsletterSubscribeFormFields> =>
  Yup.object({
    email: createEmailSchema(formatMessage),
    consent: createRequiredBooleanSchema(formatMessage)
  });

export default newsletterSubscribeFormSchemaValidationV2;
